import axios, { AxiosResponse } from "axios";

export default class Peticion {
    url: string = String(process.env.NODE_ENV === "production" ? process.env.REACT_APP_API : process.env.REACT_APP_API_DEBUG);

    GET<T>(url: string, parametros?: any): Promise<AxiosResponse<T>> {
        return axios.get<T>(this.url + url, {
            params: parametros
        });
    }

    POST<T>(url: string, datos: any): Promise<AxiosResponse<T>> {
        return axios.post<T>(this.url + url, datos);
    }

    PUT<T>(url: string, datos: any): Promise<AxiosResponse<T>> {
        return axios.put<T>(this.url + url, datos);
    }

    DELETE<T>(url: string, parametros?: any): Promise<AxiosResponse<T>> {
        return axios.delete<T>(this.url + url, {
            params: parametros
        });
    }
}